import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  headSets: {
    height: '1.5rem',
    width: '1.5rem',
    color: neutral.D14,
  },
  itemsContainer: {
    marginTop: '2rem',
    '@media (width >= 60rem)': {
      marginTop: '2.5rem',
    },
  },
});
